import { render, staticRenderFns } from "./PartnerCarousel.vue?vue&type=template&id=67644e7a&"
import script from "./PartnerCarousel.vue?vue&type=script&lang=js&"
export * from "./PartnerCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PartnerCarousel.vue?vue&type=style&index=0&id=67644e7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports